import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "@/lib/useSEO";

export default function Copyright() {
  useSEO({
    title: "Copyright Notice — Maqam",
    description: "Maqam is a registered intellectual-property work (US Copyright filing #1-15151075481). All rights reserved.",
    path: "/copyright",
  });
  return (
    <main className="min-h-screen bg-[#0b0b0c] text-white px-6 py-16">
      <div className="max-w-3xl mx-auto">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-gray-500 mb-3">
          / Legal · Copyright Notice
        </div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-2">
          © 2026 Maqam — All Rights Reserved.
        </h1>
        <p className="text-gray-400 text-sm mb-10">
          Filed under the laws of the Kingdom of Saudi Arabia.
        </p>

        <section className="space-y-8 text-gray-300 leading-relaxed">
          <div>
            <h2 className="text-xl font-bold text-white mb-2">Owner &amp; Domicile</h2>
            <p>
              <strong className="text-white">Maqam</strong> — Riyadh, Kingdom of Saudi Arabia.<br />
              Sole proprietor / corporate registration pending with the Saudi Authority for Intellectual Property
              (SAIP) and the Saudi Ministry of Commerce.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-white mb-2">Protected Works</h2>
            <p className="mb-2">All material on this platform is the exclusive intellectual property of Maqam, including:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-400">
              <li>Source code (frontend, backend, infrastructure)</li>
              <li>The "Maqam" word mark, bracket-letter logo, and trade dress</li>
              <li>Job-aggregation database compilations</li>
              <li>AI prompt templates and conversation flows (Marcus, Chefarzt, Patient roles)</li>
              <li>The clinical case library (15+ cases, German &amp; English)</li>
              <li>UI/UX patterns: faceted job search, voice mock interview, OSCE-style exam mode</li>
              <li>Bilingual translation files (English / العربية / Deutsch)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-bold text-white mb-2">Saudi Legal Framework</h2>
            <p className="mb-2">This work is protected under:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-400">
              <li>Saudi Copyright Law (Royal Decree No. M/41 of 2003)</li>
              <li>Personal Data Protection Law (PDPL, 2023)</li>
              <li>Regulations of the Saudi Authority for Intellectual Property (SAIP)</li>
              <li>Communications, Space &amp; Technology Commission (CST) rules</li>
              <li>Berne Convention &amp; TRIPS Agreement (international protection)</li>
            </ul>
            <p className="mt-3">
              Disputes are resolved exclusively before the competent courts of the Kingdom of Saudi Arabia.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-white mb-2">No License Granted</h2>
            <p>
              No part of the Software may be reproduced, distributed, modified, sub-licensed, sold, leased,
              hosted, mirrored, decompiled, reverse-engineered, or used to train any machine-learning model —
              in whole or in part — without the prior written consent of Maqam.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-white mb-2">Report Infringement / DMCA</h2>
            <p className="mb-2">
              If you believe content on this site infringes a copyright you own, or you've found
              unauthorized copies of Maqam content elsewhere, contact us:
            </p>
            <div className="border border-white/10 bg-white/5 rounded p-4 font-mono text-sm">
              <div>📧 <a href="mailto:copyright@maqam-ksa.com" className="text-white underline">copyright@maqam-ksa.com</a></div>
              <div>📧 <a href="mailto:legal@maqam-ksa.com" className="text-white underline">legal@maqam-ksa.com</a> (general legal)</div>
              <div className="text-gray-500 mt-2 text-xs">
                Please include: the URL of the infringing material, proof of ownership, and your full contact details.
                We respond within 7 business days.
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-bold text-white mb-2">Registration Status</h2>
            <p>
              U.S. Copyright Office filing reference: <span className="font-mono text-white">#1-15151075481</span>
              <span className="text-gray-500 ml-2">(submitted April 27, 2026 — awaiting examiner review, typical turnaround 3–6 months)</span>
            </p>
            <p>
              Saudi Authority for Intellectual Property (SAIP) filing: <span className="font-mono text-gray-500">[to be filed]</span>
            </p>
            <p className="text-gray-500 text-sm mt-3">
              Under Article 5 of the Berne Convention (to which both the United States and Saudi
              Arabia are signatories), copyright protection arises automatically upon creation.
              Registration reinforces enforcement but is NOT a prerequisite for ownership.
              All material on this site is protected worldwide as of its creation date in 2026.
            </p>
          </div>
        </section>

        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/privacy" className="text-gray-400 hover:text-white underline">Privacy Policy</Link>
          <Link to="/terms" className="text-gray-400 hover:text-white underline">Terms of Service</Link>
          <Link to="/" className="text-gray-400 hover:text-white underline">← Back to Maqam</Link>
        </div>
      </div>
    </main>
  );
}
